import { useQuery } from '@tanstack/react-query';
import { api } from '@/shared/api/client';
import type { ContinueResponse } from '@formency/shared';

export const continueKeys = {
  all: ['f', 'continue'] as const,
};

export function useContinue(options?: { enabled?: boolean }) {
  return useQuery<ContinueResponse>({
    queryKey: continueKeys.all,
    queryFn: () => api.get<ContinueResponse>('/me/continue'),
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: 'always',
    refetchInterval: 60_000,
    ...options,
  });
}
